import { render, staticRenderFns } from "./ChangePasswordBody.vue?vue&type=template&id=d39fd288&scoped=true&"
import script from "./ChangePasswordBody.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordBody.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordBody.vue?vue&type=style&index=0&id=d39fd288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39fd288",
  null
  
)

export default component.exports